import React from "react";
import ProfileSetting from "feature/profile-setting/profile-setting";
import {ProfileSettingProvider} from "feature/profile-setting/use-profile-setting";

const ProfileSettingContainer = () => {
  return (
    <ProfileSettingProvider>
      <ProfileSetting />
    </ProfileSettingProvider>
  );
};

export default ProfileSettingContainer;
